<div class="flex flex-col items-center justify-center w-full h-full">
  <div
    class="px-1 md:px-6 w-full h-[30%] mb-12 flex flex-col items-center justify-center relative">
    <div class="flex items-center justify-center absolute inset-0 z-0">
      <img
        src="assets/ccs.svg"
        alt="CCS Logo Background"
        class="w-full h-full opacity-10" />
    </div>
    <fa-icon
      [icon]="faHourglass"
      size="10x"
      class="text-neutral-600 relative z-10" />
    <h1 class="text-6xl text-neutral-600 mt-6 relative z-10">
      Work in Progress
    </h1>
    <p class="text-neutral-600 text-lg max-w-xl text-center mt-2 relative z-10">
      This feature is coming soon! Our CCS development team is working to make
      it available soon. Thank you for your patience!
    </p>
  </div>
  <div class="w-[170px]">
    <ui-button
      variant="secondary"
      [outline]="true"
      size="sm"
      class="cursor-pointer w-[170px]"
      (click)="onGoBack()"
      >Go Back</ui-button
    >
  </div>
</div>
